import * as React from 'react';
import { CalendarSurfaceItemContentProps } from './CalendarSurfaceItem.types';
import { observer } from 'mobx-react';
import { renderCharmWrapper, renderIconWrapper } from '../CalendarSurfaceItemComponentRenderer';

let classNames = require('classnames');
let styles = require('../CalendarSurfaceItem.scss');

/**
 * The Component for a Calendar Surface item under 45 minutes long
 */
@observer
export default class CalendarSurfaceItemUnder45 extends React.Component<
    CalendarSurfaceItemContentProps,
    {}
> {
    render() {
        let { item, colorScheme, charmId } = this.props;
        let contentClasses = classNames(
            styles.itemContent,
            styles.calendarItemClippingLine,
            styles.singleLineItem
        );
        const location = item.Location && item.Location.DisplayName;
        const organizer = item.Organizer && item.Organizer.Mailbox.Name;

        return (
            <>
                <div className={contentClasses}>
                    <h2 className={classNames(styles.itemSubject, styles.truncatedSubject)}>
                        {renderCharmWrapper(item, colorScheme, charmId)}
                        <span>{item.Subject}</span>
                    </h2>
                    {location && (
                        <span
                            className={classNames(
                                styles.locationWrapper,
                                styles.itemElementContent
                            )}>
                            {location}
                        </span>
                    )}
                    {item.IsMeeting && organizer && (
                        <span
                            className={classNames(
                                styles.locationWrapper,
                                styles.itemElementContent
                            )}>
                            {organizer}
                        </span>
                    )}
                </div>
                {renderIconWrapper(item, true)}
            </>
        );
    }
}
